/**
 * Format date as yyyy-mm-dd using local timezone
 */
export function formatLocalDate(date: Date): string {
  const pad = (num: number) => String(num).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
